import { CR_PATH, PAGE_DRAFT_PATH } from '../api-path';

export const getCRDetailPagePath = (source, rowDetails) => {
  source = !source ? (rowDetails?.data_source.includes('ORG') ? 'organic' : 'paid') : source;
  return {
    path: `${CR_PATH.url}?source=${source}`,
    params: `${CR_PATH.param}/${rowDetails.uuid}?source=${source}`,
  };
};

export const getPageDraftDetailPagePath = (rowDetails) => {
  return {
    path: `${PAGE_DRAFT_PATH.url}`,
    params: `${PAGE_DRAFT_PATH.param}/${rowDetails.uuid}`,
  };
};

export const NEW_PAGE_ORG_RANK = 'M';

export const LOCAL_NEW_PAGE_DATA = {
  uuid: '',
  rank: null,
  insight: null,
  insight_details: null,
  monthly_clicks: null,
  monthly_impressions: null,
  paid_monthly_clicks: null,
  paid_monthly_impressions: null,
  data_source: '',
  monthly_conversions: null,
  cat_subcat: null,
  urls_impacted: null,
  finalurl: '',
  site: '',
  suggested_implementation: null,
  created_date: '',
  updated_date: null,
  recommendations_type: 'KEYWORD',
  resolution: 'NO_CHANGE',
  keyword_alignment_score: null,
  projected_keyword_alignment_score: null,
  row_id: null,
  branded_keyword_alignment_score: null,
  non_branded_keyword_alignment_score: null,
  content_quality_score: null,
  organic_rank: NEW_PAGE_ORG_RANK,
  paid_rank: null,
  additional_metrics: null,
  isResolved: false,
  projectedContentQualityScore: null,
  updated_on: null,
  updated_by: null,
  projected_branded_alignment_score: null,
  projected_non_branded_alignment_score: null,
};
